module.exports = {"450225100":"融水镇","450225101":"和睦镇","450225102":"三防镇","450225103":"怀宝镇","450225104":"洞头镇","450225105":"大浪镇","450225106":"永乐镇","450225201":"四荣乡","450225202":"香粉乡","450225203":"安太乡","450225205":"汪洞乡","450225206":"同练瑶族乡","450225207":"滚贝侗族乡","450225208":"杆洞乡","450225209":"安陲乡","450225211":"白云乡","450225212":"红水乡","450225213":"拱洞乡","450225214":"良寨乡","450225215":"大年乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450225.json
// module id = 1916
// module chunks = 0